import PropTypes from "prop-types";
import * as React from "react";
import { Interpolate } from "react-i18next";
import { ClanResource, TooltipHeader, TooltipBody } from "@wg/wows-react-uikit";

import { TooltipMember } from "UIKit";

import { t, x } from "helpers/localization";

import styles from "./TooltipMemberContent.scss";

export const TooltipMemberContent = props => {
  let footerActions = [];
  if (props.showSendMessage) {
    footerActions.push(<div key="tooltip-member-content-send-message" className={styles.actionLeft}>{t('Отправить сообщение')}</div>);
  }
  if (props.showSelect) {
    footerActions.push(<div key="tooltip-member-content-select" className={styles.actionLeft}>{t('Выделить')}</div>);
  }
  if (props.showRightMouse) {
    footerActions.push(<div key="tooltip-member-content-context-menu" className={styles.actionRight}>{t('Вызвать контекстное меню')}</div>);
  }

  return <div>
            <TooltipHeader>
                <TooltipMember memberName={props.name} memberRank={props.rank} hasSeason={props.hasSeason} memberAchievement={props.achievement} />
            </TooltipHeader>
            {props.needResource || footerActions.length ? <TooltipBody>
                    <div className={styles.tooltipBody}>
                        {props.needResource ? <div>
                                <div className={styles.message}>
                                    <div className={styles.boldMessage}>{t('Нет допуска к клановым бонусам.:tooltip')}</div>
                                    <Interpolate i18nKey={x('Чтобы получить клановые бонусы, необходимо заработать %(needResource)s.:tooltip')} needResource={<ClanResource amount={props.needResource} />} />
                                </div>
                                <div className={styles.separator} />
                            </div> : null}
                        {footerActions}
                    </div>
                </TooltipBody> : null}
        </div>;
};
TooltipMemberContent.propTypes = {
  name: PropTypes.string,
  rank: PropTypes.number,
  hasSeason: PropTypes.bool,
  achievement: PropTypes.string,
  needResource: PropTypes.number,
  showSendMessage: PropTypes.bool,
  showSelect: PropTypes.bool,
  showRightMouse: PropTypes.bool
};

export default TooltipMemberContent;